import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppGlobals } from './app/app.globals';

// PDF.js global configuration to enhance security and prevent sandbox-related errors
if (typeof window !== 'undefined') {
    (window as any).pdfjsLib = (window as any).pdfjsLib || {};
    (window as any).pdfjsLib.GlobalWorkerOptions = (window as any).pdfjsLib.GlobalWorkerOptions || {};
    (window as any).pdfjsLib.GlobalWorkerOptions.workerSrc = '/assets/worker/pdf.worker.js';
    (window as any).pdfjsLib.GlobalWorkerOptions.isEvalSupported = false;
    (window as any).pdfjsLib.GlobalWorkerOptions.disableFontFace = true;
    (window as any).pdfjsLib.GlobalWorkerOptions.ignoreErrors = true;
    (window as any).pdfjsLib.GlobalWorkerOptions.sandboxBundleSrc = undefined;

    // Intercept unhandled promise rejections related to sandboxing
    window.addEventListener('unhandledrejection', (event) => {
        if (event.reason &&
            (event.reason.message?.includes('callSandboxFunction') ||
                event.reason.stack?.includes('pdf.sandbox.js'))) {
            event.preventDefault();
            console.warn('PDF.js sandbox error intercepted and prevented');
        }
    });
}

if (environment.production) {
    enableProdMode();
}

AppGlobals.initialize();

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
